export default "__VITE_ASSET__B2Kaal0Z__"